import React from 'react'
import './Cotizacion.css'
import { Button } from 'reactstrap';
import { Table, TableBody, TableCell, TableContainer, Paper, TableHead, TableRow, Collapse, Box } from '@material-ui/core'
import {
  estiloBtnAgregar, estiloBtnActualizar, estiloBtnNuevo, estiloFiltroEncabezados, estilosModal
} from '../../Services/PaletaDeColores';
import { Redirect } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Label } from 'reactstrap';
import { formatoNumeroTecla } from '../../Services/Validaciones';

const coloresestatuscompra = { 1: 'lblEstatusDisponible', 2: 'lblEstatusCompra1', 3: 'lblEstatusAutorizada', 4: 'lblEstatusHecho', 5: 'lblEstatusRechazada' }
const compra = { realizada: 4, rechazada: 5 }

export default class Cotizacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      salir: false,
      altura: window.innerHeight,
      anchura: window.innerWidth,
      loadingspinners: false,
      errordeacceso: false,
      accion: 1, // 1 Nuevo, 2 editar
      titulomodal: "",

      modaldetalles: false,

      tablastock: {
        encabezados: [
          "Producto",
          "Unidad de medida",
          "Cantidad",
          "Precio",
          "IVA",
          "Total",
        ],
        dimensiones: [
          "20%",
          "20%",
          "15%",
          "15%",
          "15",
          "15",
        ],
        mindimensiones: [
          "300px",
          "100px",
          "100px",
          "150px",
          "150px",
          "150px"
        ],
        elementos: []
      },
      //item: props.item,
      //listastock: props.listastock,

      colapsartabla: true,

      fondotitulosencabezados: estiloFiltroEncabezados().fondotitulosencabezados,
      fondobtnactualizar: estiloBtnActualizar().fondobtnactualizar,
      colorbtnactualizar: estiloBtnActualizar().colorbtnactualizar,
      borderbtnactualizar: estiloBtnActualizar().borderbtnactualizar,
      colorbtnnuevo: estiloBtnNuevo().colorbtnnuevo,
      fondobtnnuevo: estiloBtnNuevo().fondobtnnuevo,

      colorfondobtnragregar: estiloBtnAgregar().colorfondobtnragregar,
      colorbtnagregar: estiloBtnAgregar().colorbtnagregar,
      colorbordebtnagregar: estiloBtnAgregar().colorbordebtnagregar,

      estilosmodal: estilosModal(),

    }
  }

  async componentDidMount() {
    this.dimensiones();
    window.addEventListener("resize", this.dimensiones);
  }


  dimensiones = () => {
    this.setState({ altura: window.innerHeight, anchura: window.innerWidth })
  }

  activarSpinner = (accion) => {
    this.setState({ loadingspinners: accion })
  }

  render() {
    return (
      <>
        {/* ////////////////////   Inicio Sección Tabla   ////////////////////////////////////// */}
        <div className="marginTopSeparatorAutoCot">
          <TableContainer component={Paper} style={{ backgroundColor: this.state.fondotitulosencabezados }}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell className='rowElementAutoCot nonePaddingTopBottomAutoCot' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>
                    <div className='row paddingEncabezados align-items-end ' style={{ marginBottom: "6px", padding: "8px" }}>
                      <div className="col-12">
                        <div className='row flexNoWrapAutoCot'>
                          <div className='col-auto minPaddingTopBottomAutoCot'>
                            <button className='btnCollapsarAutoCot letraNormal'
                              style={{ color: this.state.colorbtnactualizar, backgroundColor: this.state.fondobtnactualizar, border: this.state.borderbtnactualizar }}
                              onClick={() => this.setState({ colapsartabla: !this.state.colapsartabla })}>{!this.state.colapsartabla ? "+" : "-"}</button>
                          </div>

                          <div className="col">
                            <div className='row flexNoWrapAutoCotMM'>
                              <div className='col-auto minPaddingTopBottomAutoCot d-flex align-items-center'>
                                <p className='tituloTabla' style={{ color: 'black', fontFamily: 'SharpGrotesk_normal' }}>
                                  {this.props.item.idproveedor}: <b>{this.props.item.proveedor}</b>
                                  {this.props.item.idestatuscotizacion != compra.realizada && <><br />Fecha estimada de entrega: {this.props.item.fechacompra}</>}
                                  {this.props.item.idestatuscotizacion == compra.realizada && <><br />Fecha de compra: {this.props.item.fechacompra}</>}
                                </p>
                              </div>

                              <div className='col '></div>
                              <div className="col-auto align-items-top">
                                <div style={{ paddingTop: '5px', marginBottom: [compra.realizada].includes(this.props.item.idestatuscotizacion) ? '42px' : '' }}>
                                  <div>
                                    <Label className={coloresestatuscompra[this.props.item.idestatuscotizacion]}>
                                      {this.props.item.estatuscotizacion}
                                    </Label><p></p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className='row'>
                              <div className='col-12 minPaddingTopBottomAutoCot d-flex align-items-center'>
                                <p className='tituloTabla' style={{ width: '100%', color: 'black', fontFamily: 'SharpGrotesk_normal', marginTop: '-8px' }}>
                                  {this.props.item.idestatuscotizacion == compra.rechazada &&
                                    <div className='stlMsgRechazo'>
                                      <label>{this.props.item.mensaje_estatuscotizacion}</label>
                                    </div>}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>

                    <Collapse in={this.state.colapsartabla} timeout="auto" >
                      <Box margin={1}>
                        <div className="marginTopSeparatorAutoCot" style={{ marginBottom: '20px', padding: '20px 48px 8px 48px', backgroundColor: 'white' }} >
                          <div className="container-fluid containerTablaAA anchoTablaCotProductos">
                            <div className="container-fluid">
                              <div className='row'>
                                <div>

                                  <Table hover={'true'}>
                                    <thead style={{ verticalAlign: "bottom" }}>
                                      <tr>
                                        {this.state.tablastock.encabezados.map((titulo, index) => (
                                          <th key={"tabla" + index} className="lblEncabezadosTabla letraTitulos"
                                            style={{
                                              minWidth: this.state.tablastock.mindimensiones[index], width: this.state.tablastock.dimensiones[index], color: this.state.colorencabezadostabla,
                                              textAlign: (index > 0) ? 'center' : 'left', paddingBottom: '8px', paddingLeft: '8px'
                                            }}>
                                            {titulo}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>

                                    <tbody style={{ verticalAlign: "bottom" }}>
                                      {this.props.listastock.map((item, index) => (
                                        <tr key={index} style={{ borderTop: !index ? 'solid 1px #dee2e6' : '', borderBottom: 'solid 1px #dee2e6' }}
                                          className={''} >
                                          <td /*key={"col-" + index + "-01"}*/ className="letraNormal lblSubtabla" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px' }}>
                                            {item.producto}
                                          </td>
                                          <td /*key={"col-" + index + "-02"} */ className="letraNormal lblSubtabla" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'center' }}>
                                            {item.unidadmedida}
                                          </td>
                                          <td /*key={"col-" + index + "-03"} */ className="letraNormal lblSubtabla" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'right' }}>
                                            {item.cantidad}
                                          </td>
                                          <td /*key={"col-" + index + "-04"} */ className="letraNormal lblSubtabla" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'right' }}>
                                            ${formatoNumeroTecla(item.precio, this.props.cuantosdecimales)}
                                          </td>
                                          <td /*key={"col-" + index + "-04"} */ className="letraNormal lblSubtabla" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'right' }}>
                                            ${formatoNumeroTecla(item.iva, this.props.cuantosdecimales)}
                                          </td>
                                           <td /*key={"col-" + index + "-04"} */ className="letraNormal lblSubtabla" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'right' }}>
                                            ${formatoNumeroTecla(parseFloat(item.precio)+parseFloat(item.iva), this.props.cuantosdecimales)}
                                          </td>
                                        </tr>
                                      ))}
                                      <tr style={{ borderBottom: this.props.item.idestatuscotizacion == 2 && this.props.permisoautorizacion ? 'solid 1px #dee2e6' : 'solid 1px white' }}>
                                        <td className=" txttotal" colSpan={3} style={{ color: this.state.colorcontenidotabla }}>
                                          {"Totales acumulados"}
                                        </td>


                                        <td className=" txttotal" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'right' }}>
                                          ${formatoNumeroTecla(this.props.item.totalprecios, this.props.cuantosdecimales)}
                                        </td>
                                        <td className=" txttotal" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'right' }}>
                                          ${formatoNumeroTecla(this.props.item.totalivas, this.props.cuantosdecimales)}
                                        </td>

                                        <td className=" txttotal" style={{ color: this.state.colorcontenidotabla, paddinfRight: '8px', paddingLeft: '8px', textAlign: 'right' }}>
                                          ${formatoNumeroTecla(this.props.item.total, this.props.cuantosdecimales)}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>

                                </div>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      </Box>
                    </Collapse>

                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {/* ////////////////////   Fin Sección Tabla   ////////////////////////////////////// */}
      </>
    )
  }
}
